import { render, staticRenderFns } from "./materialsTableForEdit.vue?vue&type=template&id=1005335f&"
import script from "./materialsTableForEdit.vue?vue&type=script&lang=js&"
export * from "./materialsTableForEdit.vue?vue&type=script&lang=js&"
import style0 from "./materialsTableForEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports